import React from 'react';
import styled from 'styled-components';
import { theme } from '../../../../../utils/theme';

type TitleColor = 'light' | 'dark';

const colorMap: Record<TitleColor, string> = {
  light: theme.landing.colors.light,
  dark: theme.landing.colors.primary,
};

interface TitleProps {
  text?: string;
  textWithBreaks?: React.ReactNode;
  color?: TitleColor;
  justification?: 'left' | 'center' | 'right';
  size?: 'small' | 'medium';
  className?: string;
}

export const Title: React.FC<TitleProps> = ({
  text,
  textWithBreaks,
  color = 'dark',
  justification = 'center',
  size = 'medium',
  className,
}) => {
  return (
    <Text
      className={className}
      color={colorMap[color]}
      size={size}
      justification={justification}
      dangerouslySetInnerHTML={text && !textWithBreaks ? { __html: text } : undefined}
    >
      {textWithBreaks}
    </Text>
  );
};

interface StyledTextProps {
  color: string;
  justification?: 'left' | 'center' | 'right';
  size?: 'small' | 'medium';
}

const Text = styled.h1<StyledTextProps>`
  color: ${({ color }) => color};
  font-family: 'League Spartan', sans-serif !important;
  font-size: 30px;
  font-size: ${({ size }) => {
    switch (size) {
      case 'small':
        return '30px';
      case 'medium':
        return '30px';
      default:
        return '30px';
    }
  }};
  line-height: normal;
  font-style: normal;
  font-weight: 700;
  margin: 0;
  max-width: 100%;
  text-align: ${({ justification }) => justification || 'center'};

  @media (min-width: 768px) {
    font-size: ${({ size }) => {
      switch (size) {
        case 'small':
          return '40px';
        case 'medium':
          return '50px';
        default:
          return '50px';
      }
    }};
  }

  @media (min-width: 1024px) {
    font-size: ${({ size }) => {
      switch (size) {
        case 'small':
          return '34px';
        case 'medium':
          return '65px';
        default:
          return '65px';
      }
    }};
  }
  @media (min-width: 1200px) {
    font-size: ${({ size }) => {
      switch (size) {
        case 'small':
          return '40px';
        case 'medium':
          return '65px';
        default:
          return '65px';
      }
    }};
  }
`;
